module.exports = __webpack_public_path__ + "static/img/sp_1.6067bd0.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/sports/sp_1.png
// module id = 831
// module chunks = 1